import merge from 'lodash-es/merge';
import { ThemeUICSSObject } from 'theme-ui';
import { TGetColorStateDefinition, TParsedPalette } from '../types';
import buildStateObject from './buildStateObject';
import { TGetColorsAndStatesOptions } from './getColorsAndStatesByPath';
import getColorsByDefinition from './getColorsByDefinition';
import getColorState from './getColorState';

/**
 * Esta función calcula los colores de los estados a partir de la definición
 * pasada.
 */
export default function getColorsAndStatesByDefinition(
  definition: Partial<TGetColorStateDefinition>,

  palette: TParsedPalette,
  options?: TGetColorsAndStatesOptions,
) {
  const active = getColorState(definition, 'active', palette);
  const checked = getColorState(definition, 'checked', palette);
  const disabled = getColorState(definition, 'disabled', palette);
  const focus = options?.states?.focus
    ? getColorState(definition, 'focus', palette)
    : {};
  const hover = getColorState(definition, 'hover', palette);
  const readonly = getColorState(definition, 'readonly', palette);
  const selected = getColorState(definition, 'selected', palette);

  return merge(
    options?.states?.default !== false
      ? getColorsByDefinition(definition)
      : null,
    options?.states?.checked !== false
      ? buildStateObject(checked, 'checked')
      : {},
    options?.states?.focus !== false ? buildStateObject(focus, 'focus') : {},
    options?.states?.hover !== false ? buildStateObject(hover, 'hover') : {},
    options?.states?.active !== false ? buildStateObject(active, 'active') : {},
    options?.states?.selected !== false
      ? buildStateObject(selected, 'selected')
      : {},
    options?.states?.disabled !== false
      ? buildStateObject(disabled, 'disabled')
      : {},
    options?.states?.readonly !== false
      ? buildStateObject(readonly, 'readonly')
      : {},
    options?.mergeObject,
  ) as ThemeUICSSObject;
}
